import { Suspense, lazy, memo } from 'react'
import { useRootContext } from '@/app/services/RootProvider/RootProvider'
import Loader from '@/components/interface/Loader/Loader'

const Home = lazy(
  () => import(/* webpackChunkName: "route-home" */ '@/pages/Home/Home')
)

const Team = lazy(
  () => import(/* webpackChunkName: "route-team" */ '@/pages/Team/Team')
)

const Missions = lazy(
  () => import(/* webpackChunkName: "route-team" */ '@/pages/Missions/Missions')
)

/**
 *
 * The `Routes` container component manages the routing for the application.
 * @param {object} props - the component props
 * @returns {ReactElement} the element
 */
function Routes (props) {
  const { route } = useRootContext()

  return (
    <Suspense fallback={<Loader.Suspense />}>
      {route.type === 'home' && <Home />}
      {route.type === 'team' && <Team />}
      {route.type === 'missions' && <Missions />}
    </Suspense>
  )
}

export default memo(Routes)
